import { render, staticRenderFns } from "./b2b.vue?vue&type=template&id=8c58264e&scoped=true&lang=html"
import script from "./b2b.vue?vue&type=script&lang=js"
export * from "./b2b.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c58264e",
  null
  
)

export default component.exports